import CryptoJS from "crypto-js";

export const cryptoSHA1 = (value: string): string =>
  CryptoJS.SHA1(value).toString();
